import React from 'react';
import { FadeIn, Section } from './Shared';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Download Your Guide',
    desc: 'Get instant access to all 21 recipes and the grocery cheat sheet right to your inbox.'
  }, {
    num: '02',
    title: "Pick a '10-Minute' Starter",
    desc: 'Begin with the Hearty Steak & Egg plate or a Fresh Wrap to build momentum quickly.'
  }, {
    num: '03',
    title: 'Track the Change',
    desc: 'Watch the bloating disappear as you hit your macro goals effortlessly and deliciously.'
  }];
  return <Section className="bg-cream-dark" data-id="element-174">
      <FadeIn data-id="element-175">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-176">
          How It Works
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-177">
        {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.2} data-id="element-178">
            <div className="relative bg-white p-8 rounded-2xl shadow-sm text-center h-full" data-id="element-179">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-terracotta text-white rounded-full flex items-center justify-center text-xl font-bold font-serif shadow-md" data-id="element-180">
                {step.num}
              </div>
              <h3 className="text-xl font-bold mt-6 mb-4 font-sans" data-id="element-181">
                {step.title}
              </h3>
              <p className="text-charcoal-light" data-id="element-182">{step.desc}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}
export function Proof() {
  return <Section data-id="element-183">
      <FadeIn data-id="element-184">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-cream-dark flex flex-col md:flex-row items-center gap-8" data-id="element-185">
          <div className="w-full md:w-1/3" data-id="element-186">
            <div className="aspect-square rounded-full overflow-hidden border-4 border-cream max-w-[200px] mx-auto" data-id="element-187">
              <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=400&q=80" alt="Happy woman" className="w-full h-full object-cover" data-id="element-188" />
            </div>
          </div>
          <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-189">
            <h3 className="text-2xl font-bold mb-4 text-sage" data-id="element-190">
              What changes in 7 days:
            </h3>
            <blockquote className="text-xl md:text-2xl font-serif italic text-charcoal leading-relaxed mb-6" data-id="element-191">
              "Most readers report a significant drop in 'water weight' and a
              total disappearance of late-night sugar cravings within the first
              week of following these high-protein recipes."
            </blockquote>
            <div className="flex items-center justify-center md:justify-start gap-1 text-terracotta" data-id="element-192">
              {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-6 h-6 fill-current" viewBox="0 0 20 20" data-id="element-193">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-194" />
                </svg>)}
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}